import { environment } from '@/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Pagination } from '../types/pagination.type';

@Injectable({
  providedIn: 'root',
})
export class HttpService<T> {
  protected baseUrl: string = environment.api.baseUrl;
  private headers: HttpHeaders;
  constructor(private http: HttpClient) {
    this.headers = new HttpHeaders();
    this.headers.append('Content-Type', 'application/x-www-form-urlencoded');
  }

  public getAll(endpoint: string): Observable<T[]> {
    const url = `${this.baseUrl}${endpoint}`;
    return this.http.get<T[]>(url, {
      headers: this.headers,
    });
  }

  public getAllWithPagination(endpoint: string): Observable<Pagination<T>> {
    const url = `${this.baseUrl}${endpoint}`;
    return this.http.get<Pagination<T>>(url, {
      headers: this.headers,
    });
  }

  public post(endpoint: string, data: Partial<T>): Observable<T> {
    const url = `${this.baseUrl}${endpoint}`;
    return this.http.post<T>(url, data, {
      headers: this.headers,
    });
  }

  public delete(endpoint: string, data: Partial<T> = {} as Partial<T>): Observable<T> {
    const url = `${this.baseUrl}${endpoint}`;
    return this.http.delete<T>(url, {
      headers: this.headers,
      body: data,
    });
  }

  public put(endpoint: string, data: T): Observable<T> {
    const url = `${this.baseUrl}${endpoint}`;
    return this.http.put<T>(url, data, {
      headers: this.headers,
    });
  }

  public patch(endpoint: string, data: Partial<T>): Observable<T> {
    const url = `${this.baseUrl}${endpoint}`;
    return this.http.patch<T>(url, data, {
      headers: this.headers,
    });
  }

  public getOne(endpoint: string): Observable<T> {
    const url = `${this.baseUrl}${endpoint}`;
    return this.http.get<T>(url, {
      headers: this.headers,
    });
  }
}
